import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const FAILURE_MESSAGES = {
  block_not_found: 'This block could not be found. Please refresh the page or contact support.',
  ranch_not_assigned: 'Assign this block to a ranch to update its recommendation.',
  recommendations_disabled: 'Irrigation recommendations are disabled for this block. Enable them to generate an updated recommendation.',
  boundary_missing: 'Add a boundary for this block to generate an updated recommendation.',
  irrigation_data_missing: 'Complete the irrigation setup for this block to generate an updated recommendation.',
  sensors_not_found: 'Add a soil sensor to this block to generate an updated recommendation.',
  sensors_offline: 'The soil sensors for this block are offline. Check their connection and try again.',
  irrigation_model_unsupported: 'The selected irrigation model is not supported. Choose a supported model to update the recommendation.',
  recommendation_data_invalid: 'A recommendation could not be generated from the available block, sensor, and forecast data.',
  recommendation_refresh_failed: 'The recommendation could not be updated due to an unexpected error. Please try again or contact support.',
};

const GENERIC_FAILURE_MESSAGE = 'The recommendation could not be updated. Please try again or contact support.';
const PENDING_MESSAGE = 'Changes applied, recommendation update in progress…';

export function RecommendationRefreshStatusMessage({ refreshStatus }) {
  const { t } = useTranslation();

  if (refreshStatus?.status === 'pending') {
    return (
      <div className="recommendation-refresh-status recommendation-refresh-status-pending" role="status">
        <Typography.Text>{t(PENDING_MESSAGE)}</Typography.Text>
      </div>
    );
  }

  if (refreshStatus?.status !== 'failed') {
    return null;
  }

  const message = FAILURE_MESSAGES[refreshStatus.failureReason] || GENERIC_FAILURE_MESSAGE;
  return (
    <div className="recommendation-refresh-status recommendation-refresh-status-failed" role="alert">
      <Typography.Text>{t(message)}</Typography.Text>
    </div>
  );
}

RecommendationRefreshStatusMessage.propTypes = {
  refreshStatus: PropTypes.shape({
    status: PropTypes.string,
    failureReason: PropTypes.string,
  }),
};

RecommendationRefreshStatusMessage.defaultProps = {
  refreshStatus: null,
};
